import React from "react";

const BookletCard = ({ title, image, link }) => {
  return (
    <div
      className="
        group relative overflow-hidden rounded-2xl
        bg-white shadow-lg
        transition-all duration-300
        hover:-translate-y-1 hover:shadow-2xl
      "
    >
      {/* IMAGE */}
      <img
        src={image}
        alt={title}
        loading="lazy"
        className="
          w-full
          h-[220px] sm:h-[280px] md:h-[320px] lg:h-[360px]
          object-cover
          transition-transform duration-700
          group-hover:scale-105
        "
      />

      {/* THEME OVERLAY (DESKTOP HOVER) */}
      <div
        className="
          absolute inset-0
          bg-gradient-to-t
          from-orange-main/90
          via-orange-main/70
          to-orange-light/40
          opacity-0
          group-hover:opacity-100
          transition-opacity duration-500
          hidden sm:block
        "
      />

      {/* CENTER CONTENT (DESKTOP HOVER) */}
      <div
        className="
          absolute inset-0 z-10
          hidden sm:flex
          flex-col items-center justify-center
          text-center text-white
          opacity-0
          group-hover:opacity-100
          translate-y-6
          group-hover:translate-y-0
          transition-all duration-500
          px-6
        "
      >
        {/* DESKTOP HEADING */}
        <h3
          className="
            text-lg md:text-xl
            font-semibold
            tracking-wide
            leading-snug
            line-clamp-2
            mb-4
          "
        >
          {title}
        </h3>

        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="
            border border-white/80
            px-5 py-2
            rounded-full
            text-sm font-medium
            hover:bg-white hover:text-orange-main
            transition
            inline-block
          "
        >
          View Booklet
        </a>
      </div>

      {/* BOTTOM CONTENT (MOBILE + NORMAL VIEW) */}
      <div
        className="
          absolute bottom-0 w-full
          bg-orange-main
          px-4 py-4 sm:px-5 sm:py-5
          transition-opacity duration-300
          sm:group-hover:opacity-0
        "
      >
        {/* MOBILE HEADING */}
        <h3
          className="
            text-white
            text-sm sm:text-base
            font-semibold
            tracking-wide
            leading-snug
            line-clamp-2
            mb-2
          "
        >
          {title}
        </h3>

        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="
            border border-white/80
            text-white
            px-4 py-1.5 sm:px-5 sm:py-2
            rounded-full
            text-xs sm:text-sm
            hover:bg-white hover:text-orange-main
            transition
            inline-block
          "
        >
          View Booklet
        </a>
      </div>
    </div>
  );
};

export default BookletCard;
